import {Component, Input} from '@angular/core';

@Component({
  templateUrl: './custom-map.component.html',
  selector: 'custom-map',
  styles: [`
    .map-cluster {
      height: 600px;
    }
  `]
})
export class CustomMapComponent {
  @Input() locations = {};
  @Input() center = {lat: 0, lon: 0};

  objectKeys = Object.keys;
}



// WEBPACK FOOTER //
// ./src/app/reports/map/components/custom-map/custom-map.component.ts